import { render, staticRenderFns } from "./suola.vue?vue&type=template&id=6617254b&"
import script from "./suola.vue?vue&type=script&lang=js&"
export * from "./suola.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports